export default {
  year: getYear(),
  month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  month3Letter: ['Jan', 'Feb', 'Mar', 'Apr', 'May',' Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
  engineer: [{
    "0": {
      "user_id": "0201506",
      "name": "Khanafi Purnomo Aji Sugi Pawira",
      "vc_user_id": 953,
      "ticket": [{
        "ticket_id": 172842,
        "problem": "PASANG BARU PERANGKAT\r\nNAMA   : JEFFRY\t\r\nALAMAT : JL. STRAWBERRY NO. 28 M MEDAN \r\nPAKET  : Internet Broadband Wireless Silver",
        "status": "Open",
        "address": "JL. STRAWBERRY NO. 28 M MEDAN "
      }],
      "address": [
        "JL. STRAWBERRY NO. 28 M MEDAN "
      ],
      "ticket_count": 1,
      "ticket_status": "working",
      "ticket_time": "1555403490959",
      "liveInfo": {
        "id": 953,
        "name": "Khanafi Purnomo Aji Sugi Pawira",
        "gender": null,
        "user_name": "khanafi.sp@gmail.com",
        "status": "Available",
        "status_ticket": "15:31 Waiting",
        "status_ticket_detail": {
          "time": "1555403490959",
          "status": "working"
        },
        "last_update_time": 1555403492757,
        "nearest_street": "Jl. Blueberry No.8f, Medan Estate, Percut Sei Tuan, Kabupaten Deli Serdang, Sumatera Utara 20221, Indonesia",
        "battery": 38,
        "rest_card": 1,
        "ticket_open_today": 1,
        "photo_prove": 0,
        "lat": 3.6351796,
        "lng": 98.7033554,
        "accuracy": 27.174,
        "comment": null,
        "photo": "https://api.track2ticket.com/v1/user/photo/07807ba7563a9395c1e1.jpg",
        "photo_cdn": "https://cdn.track2ticket.com/photo/953/07807ba7563a9395c1e1.jpg",
        "phone": "081316608550",
        "ca_id": 255291,
        "position_updated_at": "1555403492757",
        "status_updated_at": "1555403492757",
        "gps_mode": "high",
        "gps_interval": "300"
      }
    }
  },
    {
      "1": {
        "user_id": "0201842",
        "name": "Ilham Surya",
        "vc_user_id": 5365,
        "ticket": [{
          "ticket_id": 172842,
          "problem": "PASANG BARU PERANGKAT\r\nNAMA   : JEFFRY\t\r\nALAMAT : JL. STRAWBERRY NO. 28 M MEDAN \r\nPAKET  : Internet Broadband Wireless Silver",
          "status": "Open",
          "address": "JL. STRAWBERRY NO. 28 M MEDAN "
        }],
        "address": [
          "JL. STRAWBERRY NO. 28 M MEDAN "
        ],
        "ticket_count": 1,
        "ticket_status": "working",
        "ticket_time": "1555401789924",
        "liveInfo": {
          "id": 5365,
          "name": "ilham surya",
          "gender": "M",
          "user_name": "ilhamsurya0911@gmail.com",
          "status": "Available",
          "status_ticket": "15:03 Waiting",
          "status_ticket_detail": {
            "time": "1555401789924",
            "status": "working"
          },
          "last_update_time": 1555403272266,
          "nearest_street": "Jl. Strawberry No.881, Medan Estate, Percut Sei Tuan, Kabupaten Deli Serdang, Sumatera Utara 20221, Indonesia",
          "battery": 50,
          "rest_card": 1,
          "ticket_open_today": 1,
          "photo_prove": 0,
          "lat": 3.6352078,
          "lng": 98.7031184,
          "accuracy": 31.535,
          "comment": null,
          "photo": "https://api.track2ticket.com/v1/user/photo/11EGF_1549003363040.png",
          "photo_cdn": "https://cdn.track2ticket.com/photo/5365/11EGF_1549003363040.png",
          "phone": "null",
          "ca_id": 255291,
          "position_updated_at": "1555403272266",
          "status_updated_at": "1555403272266",
          "gps_mode": "high",
          "gps_interval": "300"
        }
      }
    }
  ]
}

function getYear() {
  var d = new Date();
  var n = d.getFullYear();
  var data = []
  var i, year
  for (i = 10; i >= 0 ; i--) {
    year = n - i
    data.push(year)
  }
  return data
}
